import { mqMin, tok, tokPx } from '@sunwebgroup/ui-components'
import {
  Breadcrumbs,
  Typography,
} from '@sunwebgroup/ui-components/uds'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'
import { Footer } from '@/scopes/common/components'
import { Header } from '@/scopes/common/components/Header'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { OverlayBanner } from '../../../common/components'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

const ContentWrapper = styled.main`
  background-color: ${tok('semantics_views_tinted_background_color')};
  flex-grow: 1;
  padding: 0;
  color: ${tok('semantics_content_color')};
`

const Content = styled.div`
  align-items: start;
  
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  padding-top: ${tokPx('primitives_space_16')};
  max-width: ${tokPx('primitives_area_size_1440')};
  padding: ${tokPx('primitives_space_16')} 0 ${tokPx('primitives_space_32')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    padding: ${tokPx('primitives_space_24')} ${tokPx('primitives_space_32')} ${tokPx('primitives_space_32')};
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    padding: ${tokPx('primitives_space_32')} ${tokPx('primitives_space_48')} ${tokPx('primitives_space_48')};
  }
`

const BreadcrumbsStyled = styled(Breadcrumbs)`
  padding-left: ${tokPx('primitives_space_16')};
  @media ${mqMin('primitives_breakpoint_m_min')} {
    padding-left: 0;
  }
`

const Title = styled(Typography)`
  ${Typography.modVariant('display-g-regular')};
  margin: ${tokPx('primitives_space_16')} 0;
  padding-left: ${tokPx('primitives_space_16')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    ${Typography.modVariant('display-f-regular')};
    padding-left: 0;
    margin: ${tokPx('primitives_space_24')} 0;
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    ${Typography.modVariant('display-e-regular')};
    margin-bottom: ${tokPx('primitives_space_32')};
  }
`

const FooterStyled = styled(Footer)`
  background-color: ${tok('semantics_views_tinted_background_color')};
`

export function UserProfileLayout({ children, banner }: { children: React.ReactNode, banner?: { type: 'danger' | 'success', text: string } }) {
  const intl = useIntl()
  const myPortalLink = useConfiguration('links.myPortal')

  return (
    <Wrapper>
      <Header hideLiveSearch />
      <ContentWrapper id="main-content" tabIndex={-1}>
        <Content>
          <BreadcrumbsStyled
            items={[
              { id: 'home', label: intl.formatMessage({ id: 'breadcrumb_home' }), href: '/' },
              { id: 'account', label: intl.formatMessage({ id: 'breadcrumb_account' }), href: myPortalLink },
              { id: 'user-profile', label: intl.formatMessage({ id: 'breadcrumb_user_profile' }) },
            ]}
          />
          {banner && <OverlayBanner color={banner.type} message={banner.text} />}
          <Title forwardedAs="h1">{intl.formatMessage({ id: 'user_profile_title' })}</Title>
          {children}
        </Content>
      </ContentWrapper>
      <FooterStyled />
    </Wrapper>
  )
}
